import { SocialAuthServiceConfig } from './../../node_modules/@abacritt/angularx-social-login/socialauth.service.d';
import { ApplicationConfig, importProvidersFrom, inject } from '@angular/core';
import { provideRouter, RouterModule } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { provideTranslocoConfig } from './shared/config/transloco-http-loader';
import { GoogleLoginProvider, SocialLoginModule } from '@abacritt/angularx-social-login';
import { environment } from '../environments/environment';
import { MdbModalModule } from 'mdb-angular-ui-kit/modal';
import { provideAnimations } from '@angular/platform-browser/animations';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { NgIdleModule } from '@ng-idle/core';
import { SeoService } from './services/seo.services';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideClientHydration(),
    provideHttpClient(withFetch()),
    provideAnimations(),
    provideTranslocoConfig,
    importProvidersFrom(
      SocialLoginModule,
      NgbDatepickerModule,
      NgIdleModule.forRoot(),
      NgIdleKeepaliveModule.forRoot()
    ),
    {
      provide: 'SocialAuthServiceConfig',
      useValue: <SocialAuthServiceConfig>{
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              environment.googleClientId,
              { oneTapEnabled: true }      // optional
            )
          }
        ],
        onError: (err) => console.error(err)
      }
    },
    importProvidersFrom(MdbModalModule, RouterModule.forRoot(routes)),
    { provide: 'SEO_INIT', useFactory: () => inject(SeoService) }
  ]
};
